import React, { useState } from "react";
import { ArrowRepeat, Trash } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";
const uuid = uuidv4();
const FlipCardGenerator = ({ openModal }) => {
  const [flipCards, setFlipCards] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = [...flipCards];
    const date = new Date();

    const result =
      `<div id="${uuid}" />` +
      "<FlipCard data={" +
      JSON.stringify(data) +
      "}" +
      "id=" +
      JSON.stringify("flipcards " + date) +
      "key=" +
      JSON.stringify("flipcards " + date) +
      "/> ";
    openModal(result);
  };

  ////////////////////new

  const addFlipCard = () => {
    setFlipCards([...flipCards, { front: "", back: "" }]);
  };
  const handleCardFrontChange = (index, value) => {
    const updatedCards = [...flipCards];
    updatedCards[index].front = value;
    setFlipCards(updatedCards);
  };
  const handleCardBackChange = (index, value) => {
    const updatedCards = [...flipCards];
    updatedCards[index].back = value;
    setFlipCards(updatedCards);
  };

  const deleteFlipCards = (id) => {
    setFlipCards([...flipCards.slice(0, id), ...flipCards.slice(id + 1)]);
  };

  return (
    <>
      <div className="grid  m-auto p-2">
        <form>
          <div className="flex flex-col gap-6 ">
            {/** Cards  */}
            <div className="my-2  ">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="flipCards"
              >
                Flip Cards
              </label>
              {flipCards.map((card, index) => (
                <div className="mb-4   ">
                  <label
                    //className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-blue-500 before:border-blue-gray-200 peer-focus:before:!border-blue-500 after:border-blue-gray-200 peer-focus:after:!border-blue-500">
                    className="text-xs block text-gray-400 font-bold mb-2"
                  >
                    {"Flip Card " + index}
                  </label>
                  <div className="flex gap-2 ">
                    <textarea
                      type="text"
                      key={index}
                      value={card.front}
                      onChange={(e) =>
                        // handleChoiceChange(index, e.target.value)
                        handleCardFrontChange(index, e.target.value)
                      }
                      className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      placeholder="Front"
                    />

                    <textarea
                      type="text"
                      key={index}
                      value={card.back}
                      onChange={(e) =>
                        // handleChoiceChange(index, e.target.value)
                        handleCardBackChange(index, e.target.value)
                      }
                      className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      placeholder="Back"
                    />

                    <button type="reset" onClick={() => deleteFlipCards(index)}>
                      <Trash className="text-red-500" size={20} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <button
              className=" btn btn-square min-w-40  m-auto "
              onClick={addFlipCard}
              type="reset"
            >
              Add Card
            </button>

            <div className="flex flex-row m-auto">
              <button
                onClick={handleSubmit}
                id="submitButton"
                key="submitButton"
                type="submit"
                className=" btn btn-square min-w-40  m-auto "
              >
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default FlipCardGenerator;
